import http from './http.service';

export class ImageService {

  getById(id) {
    return http.get('/image/' + id).then(x => x.data.data);
  }
}